import React from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import Label from "../Steuerelemente/Label.jsx";
import ToggleButton from "../Steuerelemente/ToggleButton.jsx";
import Led from "../Geräte/Led.jsx";

const DigitalOutElement = observer((props) => {
  const name = props.name;
  const { manAuto, onOff, digOut, hardw } = props.data;

  //========================================================================
  // Rectangle
  const rectangleStyle = {
    position: "relative",
    left: `calc(${globalVars.scaleFactor} * 10px)`,
    width: `calc(100% - (${globalVars.scaleFactor} * 30px))`,
    height: `calc(${globalVars.scaleFactor} * 40px)`,
    backgroundColor: "rgba(83, 83, 83)",
    borderRadius: `calc(${globalVars.scaleFactor} * 5px)`,
    borderStyle: "none",
    borderWidth: "0px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0",
    paddingLeft: `calc(${globalVars.scaleFactor} * 10px)`,
    overflow: "hidden",
    whiteSpace: "nowrap",
  };

  //========================================================================
  // Label Style
  const labelStyle = {
    width: `calc(${globalVars.scaleFactor} * 605px)`,
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontSize: `calc(${globalVars.scaleFactor} * ${props.style.textFontSize})`,
    color: "#D4CBCB",
    textAlign: "left",
  };

  //========================================================================
  // Button Style
  const buttonStyle = {
    position: "absolute",
    width: `calc(${globalVars.scaleFactor} * 80px)`,
    height: `calc(${globalVars.scaleFactor} * 30px)`,
    backgroundColor: "#000000",
    borderRadius: `calc(${globalVars.scaleFactor} * 5px)`,
    borderStyle: "none",
    fontSize: `calc(${globalVars.scaleFactor} * 12px)`,
    color: "white",
    textAlign: "center",
    lineHeight: `calc(${globalVars.scaleFactor} * 30px)`,
  };

  const buttonManAutoStyle = {
    ...buttonStyle,
    right: `calc(${globalVars.scaleFactor} * 180px)`,
  };

  const buttonOnOffStyle = {
    ...buttonStyle,
    right: `calc(${globalVars.scaleFactor} * 80px)`,
  };

  //========================================================================
  // LED Style
  const ledStyle = {
    position: "absolute",
    width: `calc(${globalVars.scaleFactor} * 18px)`,
    height: `calc(${globalVars.scaleFactor} * 18px)`,
    backgroundColor: "darkgrey",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "black",
    marginRight: "10px",
  };

  const ledDoStyle = {
    ...ledStyle,
    right: `calc(${globalVars.scaleFactor} * 35px)`,
  };

  const ledHardwStyle = {
    ...ledStyle,
    right: `calc(${globalVars.scaleFactor} * 5px)`,
  };

  return (
    <div style={{ height: `calc(${globalVars.scaleFactor} * 40px)` }}>
      <div style={rectangleStyle}>
        <Label
          style={labelStyle}
          element={null}
          props={{ text: name, visibility: "visible" }}
        />
        <ToggleButton
          style={buttonManAutoStyle}
          element={{ activeColor: "#02B032" }}
          props={{
            variable: manAuto,
            visibility: "visible",
            text: ["Hand/Auto", "", ""],
          }}
          authWrite={props.authWrite}
        />
        <ToggleButton
          style={buttonOnOffStyle}
          element={{ activeColor: "#02B032" }}
          props={{
            variable: onOff,
            visibility: "visible",
            text: ["Ein/Aus", "", ""],
          }}
          authWrite={props.authWrite}
        />
        <Led
          style={ledDoStyle}
          element={{ activeColor: "green" }}
          props={{ variable: digOut, visibility: "visible" }}
        />
        <Led
          style={ledHardwStyle}
          element={{ activeColor: "green" }}
          props={{ variable: hardw, visibility: "visible" }}
        />
      </div>
    </div>
  );
});

export default DigitalOutElement;
